module.exports = __webpack_public_path__ + "img/buffertrails_overlay.1988d50a.jpeg";